// extracted by mini-css-extract-plugin
export default {"restaurants-page":"RestaurantsPage_restaurants-page__75R9T","current-city":"RestaurantsPage_current-city__zqxnj"};